module.exports = __webpack_public_path__ + "img/nemuno sakata_lw.d782ac93.png";